import { useMetaTable } from "@/providers/MetaTableProvider";

type TableCellContentIdProps = {
  isEditing: boolean;
  index: string;
};

export const TableCellContentId: React.FC<TableCellContentIdProps> = ({
  isEditing,
  index,
}) => {
  const { page, pageSize } = useMetaTable();

  return (
    <>
      {isEditing ? (
        <></>
      ) : (
        <p>
          {!isNaN(Number(index))
            ? Number(index) + 1 + pageSize * (page - 1)
            : ""}
        </p>
      )}
    </>
  );
};
